module.exports = __webpack_public_path__ + "img/home-banner@2x.a6301bc5.png";